const transformTagName = (tagNameToBeTransformed, knownUntransformedTagName, knownUntransformedTagNameElementReference) => {
    const actualCurrentTag = knownUntransformedTagNameElementReference.tagName.toLowerCase();
    const [prefix, suffix] = actualCurrentTag.split(knownUntransformedTagName);
    return prefix + tagNameToBeTransformed + suffix;
};
const decimalNumberFormat = (inputValue) => {
    const clenedValue = inputValue.split('.').join('');
    if (clenedValue.length <= 3) {
        return clenedValue;
    }
    let resultado = '';
    let contador = 0;
    for (let i = clenedValue.length - 1; i >= 0; i--) {
        resultado = clenedValue[i] + resultado;
        contador++;
        if (contador === 3 && i !== 0) {
            resultado = '.' + resultado;
            contador = 0;
        }
    }
    return resultado;
};

export { decimalNumberFormat as d, transformTagName as t };
